import React from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TwoTextItemToggle.module.css";

interface Props {
  leftText: string;
  rightText: string;
  selected: "Left" | "Right";
  onChange: (newSelected: "Left" | "Right") => void;
  className?: string;
}

const TwoTextItemToggle: React.FC<Props> = ({
  leftText,
  rightText,
  selected,
  onChange,
  className,
}) => {
  const setLeft = () => onChange("Left");

  const setRight = () => onChange("Right");

  return (
    <div className={toClassName(styles.container, className)}>
      <div
        className={toClassName(styles.option, {
          [styles.selected]: selected === "Left",
        })}
        onClick={setLeft}
      >
        <Text variant={"body"} color={"text"}>
          {leftText}
        </Text>
      </div>

      <div
        className={toClassName(styles.option, {
          [styles.selected]: selected === "Right",
        })}
        onClick={setRight}
      >
        <Text variant={"body"} color={"text"}>
          {rightText}
        </Text>
      </div>
    </div>
  );
};

type ToggleItem<T extends string> = Readonly<{
  key: T;
  label: T;
}>;

export const ToggleV2 = <T extends string>({
  className,
  toggleData,
  selected,
  onPressed,
}: {
  className: string;
  toggleData: ToggleItem<T>[];
  selected: string;
  onPressed: (key: T) => void;
}) => {
  return (
    <div className={toClassName(styles.container, className)}>
      {toggleData.map((tab) => (
        <div
          key={tab.key}
          className={toClassName(styles.option, {
            [styles.selected]: selected === tab.key,
          })}
          onClick={() => onPressed(tab.key)}
        >
          <Text variant={"body"} color={"text"}>
            {tab.label}
          </Text>
        </div>
      ))}
    </div>
  );
};

export default TwoTextItemToggle;
